import InvestorRiskDeclarationModal from "components/InvestorCommon/InvestorRiskDeclarationModal";
import { InvestorClassificationRequirementPopup } from "components/InvestorClassificationRequirement";
import * as React from "react";
import { InvestorClassificationRequirementProvider } from "state/investorClassificationRequirement";
import { RiskDeclaration } from "state/riskDeclaration";

const ProfileProvider = ({ children }: React.PropsWithChildren) => (
	<RiskDeclaration.Provider>
		<InvestorClassificationRequirementProvider>
			{children}
			<InvestorRiskDeclarationModal />
			<InvestorClassificationRequirementPopup />
		</InvestorClassificationRequirementProvider>
	</RiskDeclaration.Provider>
);

export default ProfileProvider;
